import { render, staticRenderFns } from "./pspDetails.vue?vue&type=template&id=2afc3ab0"
import script from "./pspDetails.vue?vue&type=script&lang=js"
export * from "./pspDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports